// @flow
import * as React from "react"
import {throws} from "@swarm2/assert"
import {NotFoundView} from "./NotFoundView"
import {LoadingSpinner} from "./LoadingSpinner"

export default function Error(props: {inline?: boolean, error: Object}) {
  const {inline, error} = props
  if (error.isPending) {
    return (
      <LoadingSpinner title={"Pending: " + JSON.stringify(error.pendingKeys)} />
    )
  }
  if (error.isEmpty) {
    const Tag = inline ? LoadingSpinner : NotFoundView
    return <Tag title={"Empty: " + JSON.stringify(error.emptyKeys)} />
  }
  return throws("unknown Error2", props)
}



// WEBPACK FOOTER //
// ./src/common/Error.js